/**
 * Gifts for Every Occasion Section
 * Handles theme editor support and dynamic content updates
 */

class GiftsForOccasion extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    // Handle section reload in theme editor
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.detail.sectionId;
      if (this.closest('.shopify-section')?.id?.includes(section)) {
        this.updateLayout();
      }
    });

    // Handle block updates
    document.addEventListener('shopify:block:select', () => {
      this.updateLayout();
    });

    document.addEventListener('shopify:block:deselect', () => {
      this.updateLayout();
    });

    this.updateLayout();
  }

  updateLayout() {
    // Update grid layout if needed
    const grid = this.querySelector('.gifts-for-occasion__grid');
    if (grid) {
      // Grid layout is handled by CSS variables, but we can add logic here if needed
      const items = grid.querySelectorAll('.gifts-for-occasion__item');
      items.forEach((item) => {
        // Ensure proper card structure
        const card = item.querySelector('.gifts-for-occasion__card');
        if (card) {
          const imageWrapper = card.querySelector('.gifts-for-occasion__image-wrapper');
          const content = card.querySelector('.gifts-for-occasion__content');
          if (!imageWrapper || !content) {
            console.warn('Gifts for Occasion: Card structure incomplete');
          }
        }
      });
    }
  }
}

// Register the custom element
if (!customElements.get('gifts-for-occasion')) {
  customElements.define('gifts-for-occasion', GiftsForOccasion);
}

// Initialize existing sections on page load
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.gifts-for-occasion-wrapper');
  sections.forEach((section) => {
    if (!section.querySelector('gifts-for-occasion')) {
      const gifts = document.createElement('gifts-for-occasion');
      section.appendChild(gifts);
    }
  });
});

